export const SET_PROJECTS = 'set_projects';
export const ADD_PROJECT = 'add_project';
export const UPDATE_PROJECT = 'update_project';
export const PUBLISH_PROJECT = 'publish_project';
export const CLOSE_PROJECT = 'close_project';
export const DELETE_PROJECT = 'delete_project';